// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_im-7";
export var emphasizeQuantity = "_im-3";
export var flatBottomCorners = "_im-5";
export var productImage = "_im-0";
export var quantityContainer = "_im-2";
export var quantityHeader = "_im-6";
export var tooltip = "_im-1";
export var wrapAndEllipsesOverflow = "_im-4";